import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit, Input, isDevMode, EventEmitter, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PageHeaderComponent } from '../../components/page-header/page-header.component';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { Subscription } from 'rxjs';
import { SideNavEmitService } from '../../services/side-nav-emit.service';
import { SuccessFailureMessageComponent } from 'src/app/components/alert-message/success-failure-message.component';
import { CardsComponent } from 'src/app/components/cards/cards.component';
import { PopoverComponent } from 'src/app/components/popover/popover.component';
import { FusionButtonComponent } from 'src/app/components/fusion-button/fusion-button.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ExperiencetabComponent } from './experiencetab/experiencetab.component';
import { EducationtabComponent } from './educationtab/educationtab.component';
import { DependenttabComponent } from './dependenttab/dependenttab.component';
import { DocumentComponent } from './document/document.component';
import { LeaveHistoryComponent } from './Leave-history/Leave-history.component';
import { ApplyLeavesComponent } from './leaves/apply-leaves/apply-leaves.component';
import { HolidaydetailsComponent } from './holidaydetails/holidaydetails.component';
import { BasicinfotabComponent } from './basicinfotab/basicinfotab.component';
import { WorktabComponent } from './worktab/worktab.component';
import { BankinfotabComponent } from './bankinfotab/bankinfotab.component';
import { GlobalAppTabsComponent } from 'src/app/components/global-apps/global-app-tabs/global-app-tabs.component';
import { EmpnotifyComponent } from 'src/app/components/empnotify/empnotify.component';
import { ApprovalNotificationtabComponent } from './leaves/approval-notificationtab/approval-notificationtab.component';
import { ExpenseTabComponent } from 'src/app/components/global-apps/expense-tab/expense-tab.component';
import { ExpensesTabComponent } from './expenses/expenses-tab/expenses-tab.component';
import { ActivatedRoute } from '@angular/router';
import { GlobalValuesService } from 'src/app/services/global-values.service';
import { DataTableComponent } from 'src/app/components/data-table/data-table.component';
import { ApiService } from 'src/app/services/api.service';
import { DropDownComponent } from 'src/app/components/drop-down/drop-down.component';
import { ItEssComponent } from './it-ess/it-ess.component';
import { Constants } from 'src/app/models/Constants';
import { AlertService } from 'src/app/services/alert.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { NxtAppModule } from '@rangertechnologies/ngnxt';



@Component({
  selector: 'app-ess',
  standalone: true,
  templateUrl: './ess.component.html',
  imports: [
    CommonModule,
    PageHeaderComponent, 
    FormsModule, 
    ReactiveFormsModule, 
    SuccessFailureMessageComponent,
    CardsComponent,
    PopoverComponent,
    FusionButtonComponent,
    AngularSvgIconModule,
    ExperiencetabComponent,
    EducationtabComponent, 
    DocumentComponent, 
    DependenttabComponent,
    LeaveHistoryComponent,
    ApplyLeavesComponent,
    HolidaydetailsComponent,  
    BasicinfotabComponent, 
    WorktabComponent, 
    BankinfotabComponent,
    ApprovalNotificationtabComponent, 
    GlobalAppTabsComponent, 
    EmpnotifyComponent, 
    ExpenseTabComponent, 
    ExpensesTabComponent,
    DataTableComponent,
    DropDownComponent,
    ItEssComponent,
    FusionButtonComponent,
    ModalComponent,
    NxtAppModule
  ],
  styleUrls: ['./ess.component.css']
})
export class EssComponent implements OnInit {
  
  @Input() isHamClicked:boolean = false;
  @Output() nxtFormHandlerEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() nxtButtonHandlerEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() handleCalendarDateEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() handleCalendarEventDateEmit: EventEmitter<any> = new EventEmitter<any>();

  sideNavsubscription: Subscription;

  essTabToShow!: string ;
  pageComponentName = 'Ess';

  hideOrShowNav: string = "side-nav-container";
  errorMessage = '';
  showSubmissionMsg = false;
  showDeletedMsg = false;
  showErrorMsg = false;
  isDevMode: boolean = false;
  holidays:any;
  weekOff:any;
  sectionFilterIndex: number = 0;
  defaultDDValue = 'Select';
  selectedFinancialYear ='Select Financial Year' ;
  startYear = new Date().getFullYear();
  fyList : Array<any> = [];
  empUpdatesSubscription:Subscription;
  dropDownList: Array<any> = [];
  dropDownValue: any = 'Select month and year';
  queryMonth:any;
  payslipFile:any;
  paySlipDatum:Array<any> = [];
  openModal = false;
  modalProp:any;
  // SK25JUL24 to get the dynamic ESS
  isDynamicESS = false;
  configJSON:any;
  dynamicDetailsTabs:any;
  hideStaticDetailsTabs:any;
  dynamicLeavesTabs: any;
  hideStaticLeavesTabs: any;
  isDynamicTabs = false;
  leaveTabsList = [
    {name:"Apply Leave", subTab:"applyLeave"}, 
    {name:"Holiday Details", subTab:"holidayDetails"}, 
    {name:"Week Off", subTab:"weekOff"},
    {}
  ]
  detailsTabsList = [
    {name:"Basic Info", subTab:"basicinfo"}, 
    {name:"Work", subTab:"work"}, 
    {name:"Qualification", subTab:"qualification"},
    {name:"Experiences", subTab:"experiences"}, 
    {name:"Documents", subTab:"documents"}, 
    {name:"Dependents", subTab:"dependents"},
    {name:"Bank Information", subTab:"bank"},
    {}
  ]
  activeTab:any;
  leaveStaticTabs = ["applyLeave", "holidayDetails", "weekOff"]
  detailsStaticTabs = ["basicinfo", "work", "qualification", "experiences", "documents", "dependents", "bank"]
  dynamicTabContent: any;
  employeeId: any;
  tableInputs: any;
  data: any;
  nxtJSON: any;
  bookValue: any;
  modalProperties: any;
  languageCode="en-US"
  leaveButtonArray: any;
  dynamicComp= 'card';
  activeTabComp: any;
  multipleFilterArray: any;
  finalData: string | undefined;
  filterKeys: any;
  calendarEvent: any;


  constructor(private sideNavItem: SideNavEmitService, private errorHandler: ErrorHandlerService,private route: ActivatedRoute, private globalValues: GlobalValuesService, private datePipe: DatePipe, private apiService: ApiService, private alertService: AlertService, private activeRoute: ActivatedRoute,  private sanitizer: DomSanitizer) {
    //Code to observe, fetch the clicked Side nav item and display the respective page on the content area
    this.globalValues.globalValues();
    this.sideNavsubscription = this.sideNavItem.clickedSideNav$.subscribe(navItem => {
      // SK01APR24 hitting api based on module selection in ESS
      if(navItem === "details"){
        this.activeTab = "basicinfo" //SKS21NOV24
        if(this.employeeFinanceInfo === null || this.employeeFinanceInfo === undefined){
          this.apiService.fetchValue('/employee').subscribe((datas:any) => {
            this.selectedEmployee = datas.loggedInUser;
            this.employeeFinanceInfo = datas.financeInfo;
          });
        }
      } else if(navItem === "leaves"){
        this.activeTab = "applyLeave" //SKS21NOV24
        if(this.employeeLeaves === null || this.employeeLeaves === undefined){
          this.apiService.fetchValue('/employee/leaves').subscribe((datas:any) => {
            this.employeeLeaves = datas;
          });
        }
      } else if(navItem === "expenses"){
        if(this.employeeExpenses === null || this.employeeExpenses === undefined){
          this.apiService.fetchValue('/employee/expense').subscribe((datas:any) => {
            this.employeeExpenses = datas;
          });
        }
      } else if(navItem === "payslips"){ //SK02APR24 payslips details fetch
        this.apiService.fetchValue('/employee/payslip').subscribe
        ({
          next: (savedData:any) => {
            savedData.currentNetPay.sort((a:any, b:any) => new Date("01 " + b.month).getTime() - new Date("01 " + a.month).getTime());
            this.paySlipDatum = savedData.currentNetPay;
          }
        });
      }
      this.essTabToShow = navItem
    });
    this.isDevMode = isDevMode();
    this.empUpdatesSubscription = this.alertService.passAlertType$.subscribe((alert: any) => {
      if (alert.type === 'successFetch') { this.getValues(alert.fetchId); }
    });
  }

  selectedEmployee:any;
  employeeFinanceInfo:any;
  empGet:any
  employeeLeaves:any;
  employeeExpenses:any
  /** This is Add button function used to create a new data in that form group */
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.essTabToShow = params['activeNav'] || 'details';
    });
    this.hideStaticLeavesTabs =[]
    this.dynamicLeavesTabs =[]
    // SK25JUL24 to find the dynamic ESS and configurations
    const userDataConst:any = localStorage.getItem('userData');
    if(userDataConst) {
      const loggedInUserData = JSON.parse(userDataConst).apps;
      loggedInUserData.forEach((appArr:any) => {
        if(appArr.name === 'ess'){
          this.isDynamicESS = true;
          appArr.modules.forEach((modArr:any) => {
            if(modArr.name === 'details'){
              this.dynamicDetailsTabs = modArr.tabs;
              this.hideStaticDetailsTabs = modArr.hideStaticTabs
            }else if(modArr.name === 'leaves'){
              this.isDynamicTabs = true;
              this.dynamicLeavesTabs = modArr.tabs;
              this.hideStaticLeavesTabs = modArr.hideStaticTabs
            }
          });
        }
      });
    } else {
      console.log('waiting for the api response');
    }
    // SKS21NOV24 Merge dynamic tabs into leave and details tabs lists if dynamic tabs exist.
    this.leaveTabsList = this.dynamicLeavesTabs?.length > 0 ?  this.leaveTabsList.concat(this.dynamicLeavesTabs) : this.leaveTabsList;
    this.detailsTabsList = this.dynamicDetailsTabs?.length > 0 ?  this.detailsTabsList.concat(this.dynamicDetailsTabs) : this.detailsTabsList;
    // SK01APR24 to get employee leaves/expense/details
    if(this.selectedEmployee === null || this.selectedEmployee === undefined || this.employeeFinanceInfo === null || this.employeeFinanceInfo === null ){
      this.apiService.fetchValue('/employee').subscribe((datas:any) => {
        this.selectedEmployee = datas.loggedInUser;
        this.employeeFinanceInfo = datas.financeInfo[0];
        this.holidaysWeekOff(datas);
      });
      this.activeTab = "basicinfo"
    } 
    if(this.essTabToShow === "leaves"){
      if(this.employeeLeaves === null || this.employeeLeaves === undefined){
        this.apiService.fetchValue('/employee/leaves').subscribe((datas:any) => {
          this.employeeLeaves = datas;
        });
        this.activeTab = "applyLeave"
      }
      
    } else if(this.essTabToShow === "expenses"){
      if(this.employeeExpenses === null || this.employeeExpenses === undefined ){
        this.apiService.fetchValue('/employee/expense').subscribe((datas:any) => {
          this.employeeExpenses = datas;
        });
      }
    } else if(this.essTabToShow === "payslips"){ // payslips details fetch
      if(this.paySlipDatum.length === 0){
        this.apiService.fetchValue('/employee/payslip').subscribe
        ({
          next: (savedData:any) => {
            savedData.currentNetPay.sort((a:any, b:any) => new Date("01 " + b.month).getTime() - new Date("01 " + a.month).getTime());
            this.paySlipDatum = savedData.currentNetPay;
          }
        });
      }
    }
    
    if(this.isHamClicked){
      this.hideOrShowNav = "hideOrShowNav hide"
    }

    // the last five financial year list dropdown, that will be sent to IT declarations component
    for (let i = 0; i < 5; i++) {
      this.fyList.push(this.startYear - i + '-' + (this.startYear - (i - 1)));
    }

    // to set the current financial year as default
    const currentMonth = (new Date().getMonth() + 1);
    if((currentMonth >= 4) && (currentMonth <= 12)) {
      this.selectedFinancialYear = this.fyList[0];
    } else {
      this.selectedFinancialYear = this.fyList[1];
    }
    const token1 = localStorage.getItem('auth_token') as string;
    let empDetails = (JSON.parse(window.atob(token1.split('.')[1])));
    // this.getValues(empDetails.employeeId);
  }
  activeTabs(tab:any){
    this.activeTab = tab?.subTab;
    this.activeTabComp =tab
    console.log(this.activeTabComp)
    tab?.components?.forEach((element:any) => {
      //SKS21NOV24 switching the content based on type of component
      if(element.type === "dynamicCards"){
        this.dynamicComp = 'card';
        this.dynamicTabContent = element.cardList;
        //SKS21NOV24, If selectedEmployee values is not null, assigning that value to card data, else getting dynamically
        if(this.selectedEmployee || this.employeeFinanceInfo){
          this.employeeId = this.selectedEmployee?.employeeId;
          this.dynamicTabContent?.forEach((cardDatum:any) => {
            // SKS21NOV24 configuration for financeinfo object for cards
            if(cardDatum.config.responseObjectKey === 'financeInfo'){
              cardDatum.config.data = {};
              cardDatum.config.details.forEach((fieldsValue:any) => {
                if(this.employeeFinanceInfo) fieldsValue.value = this.getValue(this.employeeFinanceInfo||{}, fieldsValue.RF);
                cardDatum.config["data"][fieldsValue.refField] = fieldsValue.value;
              });;
            } else {
              cardDatum.config.details.forEach((fieldsValue:any) => {
                cardDatum.config.data = {};
                fieldsValue.value = this.getValue(this.selectedEmployee, fieldsValue.RF);
                cardDatum.config.data[fieldsValue.refField] = fieldsValue.value;
              });
            }
          });
        }  else {
          this.dynamicTabContent.forEach((cardDatum:any) => {
            this.dynamicGet(cardDatum.config.apiCall, cardDatum.config.endpoint, cardDatum.config);
          });
        }   
      }
      if (element.type === "table"){
        this.dynamicComp = 'table';
        this.tableInputs = element.config;
        this.dynamicTabContent = [];
        this.dynamicGet(element.config.apiCall, element.config.endpoint, element.config);

      }
      if(element.type === "buttons"){
        this.dynamicComp = 'button';
        this.leaveButtonArray = element.buttons
      }
    });
  }
  dynamicGet(apiCall:any, endPoint:any, config:any, cardDetails?:any){
    if(apiCall === 'get'){
      this.apiService.fetchValue(endPoint).subscribe((getData:any) => {
        if(config.responseObject){
          const key = config.responseObjectKey;
          if(config.type == 'openNXTPage'){
            this.nxtJSON = getData[key];
            if(cardDetails != null){
              this.bookValue = cardDetails.config.data;
            }
          } else {
            this.data = [];
            this.data = getData[key];
          }
        } else if(config.responseArray){
          if(config.type === 'tableData'){ // SKS21NOV24 assigning table data if response is an array array
            this.data = getData;
          }else if(config.type === 'card'){ // SKS21NOV24 assigning table data if response is an array array
            this.data = getData[0];
            config.details.forEach((element:any) => {
              element.value = this.data[element.RF];             
            });
          }
        }
      })
    }
  }
  getValue(element:any, column:string){
    const initialEl = element; // SKS21NOV24 fixed table search issue
    let flds = column.split('.');
    for(let i=0; i<flds.length; i++){
      let splitFlds = flds[i].split('[');
      if(splitFlds.length === 1){
        element = element[flds[i]] || '' as any;
      } else {
        let index = Number(splitFlds[1].split(']')[0]);
        element = element[splitFlds[0]][index]  || '' as any; //SKS21NOV24 To solve undefined error
      }
    }
    Object.assign(initialEl, { [column]: element }); // SKS21NOV24 Fixed Expression changed issue
    return element;
  }
  getValues(employeeId:any){
    if(this.globalValues.permissions.includes("HRM User") || this.globalValues.permissions.includes("HRM Manager") || this.globalValues.permissions.includes("Super User")){
      this.apiService.fetchValue('/hrm?employeeid='+employeeId).subscribe((getData:any)=>{
        this.selectedEmployee = getData.loggedInUser;
        this.employeeFinanceInfo = getData.financeInfo[0];
        this.employeeLeaves = getData?.leaves;
        this.employeeExpenses = getData?.expense;
        this.holidaysWeekOff(getData);
      })
      this.apiService.fetchValue('/hrm/allemployees').subscribe((datum: any) => {
        this.empGet = datum;
      })
    } else {
      this.apiService.fetchValue('/employee').subscribe((datas:any) => {
        this.selectedEmployee = datas.loggedInUser;
        this.employeeFinanceInfo = datas.financeInfo;
        this.holidaysWeekOff(datas);
      });
      this.apiService.fetchValue('/employee/leaves').subscribe((datas:any) => {
        this.employeeLeaves = datas;
      });
      this.apiService.fetchValue('/employee/expense').subscribe((datas:any) => {
        this.employeeExpenses = datas;
      });
    }
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.sideNavsubscription.unsubscribe();
  }

  sideNavChange(event: any){
    //if(this.isDevMode) console.log("asasdasdasdasdasdas",JSON.stringify(event));
  }

  saveSuccess(successMessage: any){
    this.showSubmissionMsg = true;
    setTimeout(()=>{
      this.showSubmissionMsg = false;
    }, 5000);
    this.errorMessage = '';
  }

  deleteSuccess() {
    this.showDeletedMsg = true;
    setTimeout(()=>{
      this.showDeletedMsg = false;
    }, 5000);
    this.errorMessage = "";
  }

  showError(err:any){
    this.showErrorMsg = true;
    this.errorHandler.handleError(err);
    this.errorMessage = this.errorHandler.errorMessage;
    this.alertService.messageOnPass('error', this.errorMessage);
  }

  getDatas:any;
  getUserData(){
    this.apiService.fetchValue('/user').subscribe((datas:any) => {
      this.getDatas = datas;
    });
  }

  finYear(event:any){
    this.selectedFinancialYear = event.data;
  }

  holidaysWeekOff(data:any){
    this.holidays = data.loggedInUser?.holidays || [];
    this.holidays.forEach((holidayElement:any) => {
      holidayElement.type = holidayElement.leaveType;
      const startDate = this.datePipe.transform(holidayElement.startDate, 'mediumDate');
      const endDate = this.datePipe.transform(holidayElement.endDate, 'mediumDate')
      if(startDate === endDate){
        holidayElement.days = this.datePipe.transform(holidayElement.startDate, 'mediumDate');
      } else {
        holidayElement.days = this.datePipe.transform(holidayElement.startDate, 'mediumDate') + ' to ' + this.datePipe.transform(holidayElement.endDate, 'mediumDate');
      }
    });
    const weekoffDays = data.loggedInUser?.weekoff || []; 
    const days = weekoffDays.days || [];let loopDays = '';
    days.forEach((weekOffElement:any, index:number) => {
      loopDays = loopDays + weekOffElement.value + (index < (days.length - 1)? ', ' : '');
    });
    const dayObject = {days :loopDays };
    const typeObject = {type : weekoffDays.leaveType}
    this.weekOff = [{...dayObject,...typeObject}];
  }
  
  // SK02APR24 payslip file processed as text
  processFile(url:any, payrollMonth: string, from:any) : any{
    this.payslipFile = "";
    var request = new XMLHttpRequest();
    request.open('GET', url, true);
    request.responseType = 'blob';
    request.onload = (e1:any) =>  {
        var reader = new FileReader();
        reader.readAsDataURL(request.response);
        const blob = request.response;
        // then blob is passed here to read the as text
        from === 'viewPayslip' ? this.onChange(blob, payrollMonth) : this.onChangeDownload(blob, payrollMonth);
    };
    request.send();
  }

  // SK02APR24 processed text is converted to blob
  onChange(event:any, payrollMonth:any) {
    this.payslipFile = "";
    var reader = new FileReader();
    reader.onload = (e: any) => {
      var linkSource = e.target.result;
      const byteCharacters = window.atob(linkSource);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      this.convertPdf(blob);
    };
    reader.readAsText(event);

  }  
  
  // SK02APR24 converting blob again as base64 to get the proper format
  convertPdf(filePay:any){
    var file: File = filePay;
    var reader: FileReader = new FileReader();
    reader.onload = () => {
      const res = reader.result;
      this.payslipFile = this.sanitizer.bypassSecurityTrustResourceUrl(res as any);
    };
    reader.readAsDataURL(file);
  }

  // SK02APR24 processing and downloading the base64 file
  onChangeDownload(event:any, payrollMonth:any) {
    var reader = new FileReader();
    reader.onload = (e: any) => {
      var linkSource = e.target.result;
      const byteCharacters = window.atob(linkSource);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
    
      const url = URL.createObjectURL(blob);
      const fileName = "Payslip_" + payrollMonth;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.click();
      this.alertService.messageOnPass('success', 'Payslip downloaded successfully');  
    };
    reader.readAsText(event);
  }

  // SK02APR24 download emit icon
  downloadIconEmit(evt:any){
    if(evt.element.file)this.processFile(evt.element.file, evt.element.month, 'download');;
  }

  // SK02APR24 view emit icon
  viewIconEmit(evt:any){
    this.modalProp = {
      modalTitle:"Payslip",
      modalSize:"modal-lg"
    }
    this.openModal = true;
    if(evt.element.file)this.processFile(evt.element.file, evt.element.month, 'viewPayslip');
  }

  // SK02APR24 closing opened modal
  modalClose(event:any){
    this.openModal = false;
  }
  onClickEdit(card:any){
    this.bookValue = {}; //SKS21NOV24
    if(card.isEditButton){
      this.openModal = true;
      this.modalProperties = card.editButtonActions;
      this.commonButtonClickEmit(this.modalProperties, card)
    } 
  }

  // SKS21NOV24 type of action on clicking edit
  commonButtonClickEmit(event:any, cardDetails:any){
    if(event.buttonAction == 'openModal'){
      this.openModal = true;
      this.modalProperties = event.modalProperties;
      if(this.modalProperties?.type === 'openNXTPage'){
        const url = '/nxt?name=' + this.modalProperties.pageContent;
        this.dynamicGet('get', url, this.modalProperties, cardDetails);
      }
    }
  }
  nxtFormHandlerESS(event:any){
    if(event.action == 'close'){
      this.modalClose(false);
    } else if(event.action == 'save'){ //SKS21NOV24 handling the nxt button properties for patch/post call
      let endPoint:any;
      if(this.modalProperties.isQueryParams) {
        endPoint = this.modalProperties.nxtAPI + this.modalProperties.paramsValue;
      } else {
        endPoint = this.modalProperties.nxtAPI;
      }
      const patchData = event;
      this.apiService.writeValue('patch', endPoint, patchData)
      .subscribe({
        next: (savedData:any) => {
          this.modalClose(false);
          this.alertService.messageOnPass('success', savedData.message);
        },
        error: (err: HttpErrorResponse) => {
          this.showError(err);
          
        }
      });
    } else if(event.action == 'submit'){ 
      
        let endPoint:any;
        if(this.modalProperties.isQueryParams) {
          endPoint = this.modalProperties.nxtAPI + this.modalProperties.paramsValue;
        } else {
          endPoint = this.modalProperties.nxtAPI;
        }
        const patchData = event;
        let apiCall = this.modalProperties.nxtAPICall || "post"
        this.apiService.writeValue(apiCall, endPoint, patchData)
        .subscribe({
          next: (savedData:any) => {
            this.modalClose(false);
            this.alertService.messageOnPass('success', savedData.message);
            this.activeTabs(this.activeTabComp)
          },
          error: (err: any) => {
            this.showError(err);
          }
        });
      
    }
  }
  
  onDeleteRecord(event:any){ //SKS25NOV24
    console.log(event)
    const conf = event?.tableConfigs;
    const data = event?.data;
    let queryObj:any = {};
    let endPt = conf?.dataDeleteProperties?.endpoint;
    if(conf?.dataDeleteProperties.requestParamKeys.length > 0){
      conf?.dataDeleteProperties.requestParamKeys.forEach((ele:any) => {
        if(endPt?.includes("?")){
          endPt += `&${ele}=${data[ele]}`
        } else {
          endPt += `?${ele}=${data[ele]}`
        }
      });
    }
    if(conf?.dataDeleteProperties.requestBodyValues.length > 0){
      conf?.dataDeleteProperties.requestBodyValues.forEach((ele:any) => {
        queryObj[ele] = data[ele];
      });
    }
   
    this.apiService.writeValue(conf?.dataDeleteProperties?.apiCall, endPt, Object.keys(queryObj).length > 0 ? queryObj : null).subscribe({
      next: (data: any) => {
        this.activeTabs(this.activeTabComp);
        this.alertService.messageOnPass('success', data.message);
        this.globalValues.employeeDataGet();
      },
      error: (err: HttpErrorResponse) => {
        this.showError(err);
      }
    })
  }
  onEditRecord(event:any){

  }
  hyperLinkColumnEmit(event:any){

  }
  tableCheckedDataa(event:any){

  }
  handleCalendarDate(event:any){
    this.handleCalendarDateEmit.emit(event)
  }

  // SKS21NOV24 calendar event value emit
  handleCalendarEvent(event:any){
    this.handleCalendarEventDateEmit.emit(event)
  }
  nxtFormHandler(event:any){
    this.nxtFormHandlerEmit.emit(event);
  }
  nxtButtonHandler(event:any){
    this.nxtButtonHandlerEmit.emit(event);
  }
  commonButtonClick(event:any, index:any | undefined = undefined){
    console.log(event)
    if(event.buttonAction == 'openModal'){
      this.openModal = true;
      //SKS21NOV24 Whether the modal action is to create or edit data
      if(event.buttonType === 'newRecord'){
        this.bookValue = {};
      }
      this.modalProperties = event.modalProperties;
      if(this.modalProperties?.type === 'openNXTPage' || this.modalProperties?.type === 'calendar'){ //SKS21NOV24 adding calendar  type check
        const url = '/nxt?name=' + this.modalProperties.pageContent;
        this.getData('get', url, this.modalProperties, index);
      }
    } 
  }
  getData(apiCall:any, endPoint:any, event:any, parentData:any | undefined = undefined, pageSize?:number, pageIndex?:number): void{
    if(apiCall === 'get'){
      let finalGetCall:any;
      // SKS21NOV24 if the config has endpoint with params, we will add the path to url
      if(event?.config?.isQueryParams){
        finalGetCall = endPoint + event.config?.paramsKey + event.config?.paramsValue;
      } else {
        finalGetCall = endPoint
      }
      // SKS21NOV24 adding pagination size and index to api call from data table
      if(event?.config?.pagination === true && event?.config?.pagination != undefined){
        if(event?.config.endpoint.includes('?')){
          finalGetCall = endPoint+"&pageSize="+pageSize+"&pageIndex="+pageIndex;
        } else {
          finalGetCall = endPoint+"?pageSize="+pageSize+"&pageIndex="+pageIndex;
        }
      }
      // SKS21NOV24 loader in calls
      // this.spinnerService.show();
      this.apiService.fetchValue(finalGetCall).subscribe((getData:any) => {
        // this.spinnerService.hide();
        event.config.data = [];
        if(event.config.responseObject){
          const key = event.config.responseObjectKey;
          if(event.config.type == 'openNXTPage' || event.config.type == 'calendar'){  //SKS21NOV24 adding calendar  type check
            if(getData["nxtBindInFunctionsMap"]) {
              const evalfn = eval(getData["nxtBindInFunctionsMap"][getData?.name]);
            }
            // SKS21NOV24 for hyperlink action type
              this.nxtJSON = getData[key];
              event.config.nxtJSON = getData[key]; //SK12FEB24
              // SKS21NOV24 if type is calendar
              if(event.config.type === "calendar"){              
                this.handleCalendarDate(this.calendarEvent)
              }
          } else if(event.config.type == 'openNxtButtonPage'){
            this.nxtJSON = getData[key];
            console.log('inside getTableData'); // + this.buttonNxtInput);
          } else if(event.config.type === 'card'){ // SKS21NOV24 assigning table data if response is an array array
            event.config.data = {};
            event.config.details.forEach((element:any) => {
              element.value = this.getValue(getData, element.RF);            
              event.config.data[element.refField] = element.value; //SKS21NOV24 assigning the card details in config
            });
          } else if(event.config.type === 'multiCheck'){ // SKS21NOV24 assigning checkbox data if response is an array array
            if(event.config.name === "activeCheckboxList"){
              parentData.config.activeCheckboxList = this.getValue(getData, event.config.responseObjectKey);
            } else if(event.config.name === "checkboxList"){
              parentData.config.checkboxList = this.getValue(getData, event.config.responseObjectKey);
            }
          } else if(event.config.type === "table" ||  event.config.type === "tableData"){
            this.data = [];
            event.config.data = [];
            this.data = this.getValue(getData,key);
            this.finalData = JSON.stringify(this.data);
            event.config.totalRecords = getData["totalRecords"];
            event.config.data.push(getData[key]);
            // SKS21NOV24 adding filter keys in table
            if(event?.config?.filterColumns?.length > 0){
              this.multipleFilterArray = {};
              const filtObjs:any = {};
              event.config.filterColumns.forEach((element:any) => {
                this.multipleFilterArray[element] = null;
                filtObjs[element] = [];
              });
              this.data.forEach((element: { [x: string]: any; }) => {
                event.config.filterColumns.forEach((key:any) => {
                  if(Object.keys(element).includes(key)){
                    filtObjs[key].push(element[key])
                    this.multipleFilterArray[key] =(new Set(filtObjs[key]));
                  }
                });
              });
              event.config.multipleFilterArray = this.multipleFilterArray;
              const filter:any =localStorage.getItem('tabfilter') //SKS21NOV24 get the tbfilter keys and pass to the filterRetin
              this.filterKeys=JSON.parse(filter)||{}
              this.filterRetain(this.filterKeys)
              // this.searchFilterData(event); //SKS21NOV24 calling the filterdata
            }
          } else {
            this.data = [];
            this.data = this.getValue(getData,key);
            event.config.data.push(getData[key]);
            if(event.config.type === 'nxtGetCall'){
              this.data.forEach((data:any)=>{
                const date:any = this.datePipe.transform(data.parkingDate, 'short');
                data.time = date?.split(',')[1];
                data.date = this.datePipe.transform(date?.split(',')[0], 'mediumDate');
                delete data._id;
                delete data.parkingDate;
              })
            }
          }
        } else if(event?.config?.responseArray){
          if(event.config.type === 'tableData'){ // SKS21NOV24 assigning table data if response is an array array
            this.data = getData;
            // SKS21NOV24 adding filter keys in table 
            this.finalData = JSON.stringify(this.data);
            event.config.data = getData;
            if(event.config?.filterColumns?.length > 0){
              this.multipleFilterArray = {};
              const filtObjs:any = {};
              event.config.filterColumns.forEach((element:any) => {
                this.multipleFilterArray[element] = null;
                filtObjs[element] = [];
              });
              this.data.forEach((element: { [x: string]: any; }) => {
                event.config.filterColumns.forEach((key:any) => {
                  if(Object.keys(element).includes(key)){
                    filtObjs[key].push(element[key])
                    this.multipleFilterArray[key] =(new Set(filtObjs[key]));
                  }
                });
              });
              event.config.multipleFilterArray = this.multipleFilterArray;
            }
          } else if(event.config.type === 'card'){ // SKS21NOV24 assigning table data if response is an array array
            event.config.details.forEach((element:any) => {
              element.value = getData;             
            });
          } else if(event.config.type === 'multiCheck'){ // SKS21NOV24 if response is an array 
            if(event.config.name === "activeCheckboxList"){
              parentData.config.activeCheckboxList = getData;
            } else if(event.config.name === "checkboxList"){
              parentData.config.checkboxList = getData;
            }            
          } else if(event.config.type === 'attendanceTable'){
            // SKS21NOV24 configuring attendance table
            event.config.employeeListAttendance = getData;            
          }
        }
      })
    }
  }
  filterRetain(filterKeys: any) {
    throw new Error('Method not implemented.');
  }
}